import React, { useEffect, useState } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ShareIcon from "@mui/icons-material/Share";

import { Spinner } from "react-bootstrap";
import { InvokePostServiceCall } from "../../api/apiServices";
import { API } from "../../constants/APIConstant";

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" size={24} {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
          fontSize={7}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export const TableCustom = (props) => {
  const {
    tableData,
    handleProcess,
    handleConfiguration,
    handleEVR,
    handleDelete,
    setTableData,
    handleShare,
    showUseButton,
    showProcessButton,
    showConfigureButton,
    showInfoButton,
    showShareButton,
    showDeleteButton,
    showPercentage,
    handleInfo,
    disableInfoButton,
  } = props;
  console.log(tableData, "tableData");
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteBtnLoading, setDeleteBtnLoading] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [projectId, setProjectId] = useState("");
  const [isProjectDeleted, setIsProjectDeleted] = useState(false);
  const itemsPerPage = 10;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = tableData?.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(tableData.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const tableHeight = "60px"; // Set your desired fixed height

  const handleClickOpenDeleteDialog = (project_id) => {
    setOpenDeleteDialog(true);
    setProjectId(project_id);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteBtnLoading(false);
    setOpenDeleteDialog(false);
  };

  useEffect(() => {
    if (isProjectDeleted) {
      setIsProjectDeleted(false);
    }

    if (tableData.length > 0 && showPercentage) {
      let interval = setInterval(() => {
        if (!isProjectDeleted) {
          tableData.forEach((item, index) => {
            if (
              item.status === "In Process" &&
              item.processPercentage !== 100
            ) {
              let requestBody = {
                project_id: item.project_id,
              };
              InvokePostServiceCall(API.features_get_status, requestBody)
                .then((response) => response.text())
                .then((result) => {
                  let res = JSON.parse(result);
                  let tableDataCopy = [...tableData];
                  tableDataCopy[index].processPercentage = res.result[0];
                  if (Number(res.result[0]) === 100) {
                    tableDataCopy[index].status = "Ready";
                  }
                  setTableData((prevState) => ({
                    ...prevState,
                    tableData: tableDataCopy,
                  }));
                })
                .catch((error) => {
                  console.error(error);
                });
            }
          });

          setTableData((prevState) => ({
            ...prevState,
            tableData: tableData,
          }));
        }
      }, 10000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [tableData, isProjectDeleted]);

  return (
    <>
      <div>
        {currentItems.length > 0 ? (
          <TableContainer
            className="table-container"
            style={{ minHeight: tableHeight, overflowY: "auto" }}
          >
            <Table className="table">
              <TableHead>
                <TableRow>
                  <TableCell className="table-header">Project Name</TableCell>
                  <TableCell className="table-header">Created At</TableCell>
                  <TableCell className="table-header">Created By</TableCell>
                  <TableCell className="table-header">Status</TableCell>
                  <TableCell className="table-header">Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {currentItems.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.project_id}</TableCell>
                    <TableCell>{row.created_at}</TableCell>
                    <TableCell>{row.created_by}</TableCell>
                    <TableCell>{row.status}</TableCell>
                    <TableCell className="action-buttons">
                      {showUseButton && (
                        <Button
                          variant="text"
                          title="Use"
                          onClick={() =>
                            handleEVR(row.project_id, row.created_by)
                          }
                          disabled={
                            !row.status?.includes("Ready") && showProcessButton
                          }
                        >
                          {/* Use */}
                          <ArrowCircleRightOutlinedIcon />
                        </Button>
                      )}
                      {showProcessButton && (
                        <Button
                          variant="text"
                          onClick={() =>
                            handleProcess(row.project_id, row.created_by)
                          }
                          disabled={
                            row.status === "Ready" ||
                            row.status === "In Process"
                          }
                          title="Process"
                        >
                          {/* Process */}
                          {row.status === "In Process" && showPercentage ? (
                            <CircularProgressWithLabel
                              value={row.processPercentage}
                            />
                          ) : (
                            <AutorenewOutlinedIcon />
                          )}
                        </Button>
                      )}
                      {showConfigureButton && (
                        <Button
                          variant="text"
                          title="Configure"
                          onClick={() => {
                            handleConfiguration(row.project_id);
                          }}
                        >
                          {/* Configure */}
                          <SettingsOutlinedIcon />
                        </Button>
                      )}
                      {showInfoButton && (
                        <Button
                          variant="text"
                          title="info"
                          disabled={disableInfoButton && row.status !== "Ready"}
                          onClick={() => handleInfo(row.project_id)}
                        >
                          {/* INFO */}
                          <InfoOutlinedIcon />
                        </Button>
                      )}
                      {showShareButton && (
                        <Button
                          variant="text"
                          title="Share"
                          onClick={() => handleShare(row.project_id)}
                        >
                          <ShareIcon />
                        </Button>
                      )}
                      {showDeleteButton && (
                        <Button
                          variant="text"
                          title="delete"
                          onClick={() =>
                            handleClickOpenDeleteDialog(row.project_id)
                          }
                        >
                          {/* Delete */}
                          <DeleteOutlineOutlinedIcon />
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "80vh",
            }}
          >
            {" "}
            <p style={{ fontSize: "30px" }}>No Data to show</p>
          </div>
        )}

        {currentItems.length > 0 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <IconButton
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <KeyboardArrowLeftIcon />
            </IconButton>
            <p
              style={{ marginTop: "10px" }}
            >{`Page ${currentPage} of ${totalPages}`}</p>
            <IconButton
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <KeyboardArrowRightIcon />
            </IconButton>
          </div>
        ) : (
          <></>
        )}
      </div>

      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title">
        {"Are you sure you want to delete this project?"}
      </DialogTitle> */}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this project?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button sx={{ width: "73px" }} onClick={handleCloseDeleteDialog}>
            Cancel
          </Button>
          <Button
            sx={{ width: "73px" }}
            disabled={deleteBtnLoading}
            onClick={() => {
              setDeleteBtnLoading(true);
              setIsProjectDeleted(true);
              handleDelete(projectId, handleCloseDeleteDialog);
            }}
          >
            {deleteBtnLoading ? <Spinner size="sm" /> : <>Delete</>}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
